const BACKGROUND_ID_KEY = 'selectedVideoBackgroundId';

export const saveBackgroundId = (id: string): void => {
  try {
    localStorage.setItem(BACKGROUND_ID_KEY, id);
  } catch (error) {
    console.warn('[backgroundPreference] Failed to save background id', error);
  }
};

export const getSavedBackgroundId = (): string | null => {
  try {
    return localStorage.getItem(BACKGROUND_ID_KEY);
  } catch {
    return null;
  }
};
